<template>
  <div class="game-hall">
    <Header :title="$t('游戏大厅')"></Header>
    <div class="game-nav-list">
      <div :class="{'nav-item': true, 'active': item.type === params.category}" v-for="(item,index) in tab_nav" :key="index" @click="changeGameType(item)">
        <img :src="(params.category === item.type ? item.icon_active : item.icon)" alt="">
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
    <div class="content">
      <div class="search-box">
        <div class="input-box">
          <img src="/static/image/new/game/search.png" class="icon" alt="">
          <input type="text" placeholder="搜索游戏名称" v-model="params.name"  @input="onInputSearch">
        </div>
      </div>
      <div class="cate-list">
        <div :class="{'cate-item': true, 'active': item.platform_name === params.code}" v-for="(item,index) in cate_list" :key="index" @click="changeCate(item)">{{item.platform_name}}</div>
      </div>
      <div class="list-box">
        <van-list finished-text="没有更多了" v-model="loading" offset="300" :finished="list.length === total"  @load="getList()" v-if="list.length > 0">
          <div class="list-scroll">
            <div :class="[(params.category === 'realbet' || params.category === 'sport') ? 'list-item2' : 'list-item']" v-for="(item,index) in list" :key="index">
              <img :src="item.app_img" @click="go(item.Code, item.GameCode, item.is_platform)" alt="">
            </div>
          </div>
        </van-list>

        <template v-else>
          <div v-if="!loading_start" style="margin-top: 60px; text-align: center">
            <img src="/static/image/new/agent/list-empy-img.png" style="width: 4.64rem;height: 4.64rem;" alt="" />
            <div class="text" style="color: #84B4FF;font-size: 0.37rem;margin-top: -0.8rem;">什么也没有</div>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/common/header"
import {translateText} from "../../common/utils";
export default {
  name: 'game-hall',
  data() {
    return {
      params: {
        name: '',
        category: 'lottery',
        code: 'All',
        page: 1,
        page_size: 10,
      },
      loading: false,
      loading_start: false,
      timer: null,
      total: 0,
      list: [],
      tab_nav: [
        {
          type: 'lottery',
          icon: require('../../../static/image/new/game/game-tab3.png'),
          icon_active:  require('../../../static/image/new/game/game-tab3-active.png'),
          name: '彩票'
        },
        {
          type: 'concise',
          icon: require('../../../static/image/new/game/game-tab1.png'),
          icon_active:  require('../../../static/image/new/game/game-tab1-active.png'),
          name: '电子'
        },
        {
          type: 'realbet',
          icon: require('../../../static/image/new/game/game-tab2.png'),
          icon_active:  require('../../../static/image/new/game/game-tab2-active.png'),
          name: '真人'
        },
        {
          type: 'joker',
          icon: require('../../../static/image/new/game/game-tab4.png'),
          icon_active:  require('../../../static/image/new/game/game-tab4-active.png'),
          name: '棋牌'
        },
        {
          type: 'sport',
          icon: require('../../../static/image/new/game/game-tab5.png'),
          icon_active:  require('../../../static/image/new/game/game-tab5-active.png'),
          name: '体育'
        },
      ],
      cate_list: []
    }
  },
  components: {
    Header
  },
  mounted() {
    if(this.$route.query.category) {
      this.params.category = this.$route.query.category
    }
    this.params.page = 1
    this.loading_start = true
    this.getCateList()
  },
  methods: {
    changeGameType(item) {
      this.$parent.showLoading();
      this.params.category = item.type
      this.list = []
      this.loading_start = true
      this.getCateList()
    },
    changeCate(item) {
      this.$parent.showLoading();
      this.params.code = item.platform_name
      this.initData()
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    initData() {
      this.params.page = 1
      this.list = []
      this.total = 0
      this.loading_start = true
      this.getList()
    },
    getList() {
      this.$parent.showLoading();
      // if (this.loading) return;
      this.loading = true
      this.$apiFun
        .post('/api/app/youxi_list', {
          ...this.params,
          code: this.params.code === 'All' ? '' : this.params.code
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            this.total = res.data.pagination.total_items
            const rows = res.data.hot
            if(this.params.page === 1) {
              this.list = rows;
            }else {
              this.list = [...this.list, ...rows];
            }
            this.params.page++;
          }
          this.$parent.hideLoading();
          this.loading = false
          this.loading_start = false
        })
        .catch(res => {
          this.$parent.hideLoading();
          this.loading = false
          this.loading_start = false
        });
    },
    getCateList() {
      this.cate_list = []
      this.$apiFun
        .post('/api/app/youxi_cate', {
          category: this.params.category
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            if(this.params.category !== 'lottery') {
              // 彩票不显示其他分类
              this.cate_list = res.data
            }
            this.cate_list.unshift({
              platform_name: 'All'
            })
            this.params.code = 'All'
            this.initData()
          }
        })
        .catch(res => {
        });
    },
    onInputSearch() {
      // 防抖
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.initData()
      }, 400)
    },
    async go(code, gameCode = '', is_platform = 0) {
      if (localStorage.getItem('token')) {
        if(this.params.category === 'lottery' && is_platform == 1) {
          //  is_platform == 1 平台游戏
          // 彩票跳转自己的页面
          const path = (code === 'jld28') ? '/game-room' : '/game-Liuhe-room'
          this.$router.push({path: path, query: {game_video: code, room: gameCode}})
        }else {
          this.goGamePage(code, 0, gameCode, code)
        }
      } else {
        this.$router.push({path: '/login'});
      }
    },
    goGamePage(name, type = 0, code = '', platname) {
      return new Promise((resolve, reject) => {

        this.$apiFun
          .post('/api/getGameUrl', {plat_name: name, game_type: code, game_code: this.params.category, is_mobile_url: 1})
          .then(res => {
            if (res.code != 200) {
              this.showTost(0, res.message);
            }
            if (res.code == 200) {
              if (res.data.url) {
                this.opIframe(res.data.url, platname)
              }
            }
            this.loading = false
            resolve()
          })
          .catch(res => {
            this.loading = false
            reject()
          });
      })
    },
    opIframe(url, platname) {
      if (localStorage.getItem('token')) {
        this.$parent.goNav(`/gamePage?url=${encodeURIComponent(url)}&platname=${platname}&isBack=1`);
      } else {
        this.$router.push({path: '/login'});
      }
    },

  }
}
</script>

<style lang="scss">
.game-hall {
  .van-list__error-text, .van-list__finished-text, .van-list__loading {
    width: 100%;
  }
}
</style>
<style scoped lang="scss">
.game-hall {
  background: #0D0D0D;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  .game-nav-list {
    display: flex;
    overflow-x: auto;
    .nav-item {
      width: 20%;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: .35rem 0;
      position: relative;
      img {
        width: .53rem;
        height: .53rem;
        margin-bottom: .1rem;
      }
      .title {
        font-size: .32rem;
      }
      &.active::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: 0.64rem;
        height: .06rem;
        background: #007AFF;
        border-radius: .02rem;
        margin: auto;
      }
    }
  }
  .content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    background: rgba(255, 255, 255, 0.05);
    border-top-left-radius: .64rem;
    border-top-right-radius: .64rem;
    padding: .3rem;
    .search-box {
      .input-box {
        display: flex;
        align-items: center;
        background: rgba(255, 255, 255, 0.05);
        height: 1.06rem;
        border-radius: .53rem;
        padding: 0 .4rem;
        .icon {
          flex-shrink: 0;
          margin-right: .2rem;
        }
        input {
          height: 100%;
          outline: none;
          border: none;
          background: transparent;
        }
      }
    }
    .cate-list {
      display: flex;
      overflow-x: auto;
      padding: .2rem 0;
      .cate-item {
        flex-shrink: 0;
        padding: 0rem .2rem;
        min-width: 1.3rem;
        text-align: center;
        height: .96rem;
        line-height: .96rem;
        border-radius: .6rem;
        color: rgba(255, 255, 255, 0.5);
        font-size: .34rem;
        margin-right: .2rem;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          color: #fff;
          background: #007AFF;
        }
      }
    }
    .list-box {
      padding: .3rem 0 0;
      min-height: calc(100% - 3rem);
      .list-scroll {
        display: flex;
        flex-wrap: wrap;
      }

      .list-item {
        width: 2.96rem;
        height: 4.18rem;
        margin-right: .22rem;
        margin-bottom: .22rem;
        flex-shrink: 0;
        img {
          //max-width: 100%;
          //max-height: 100%;
          //width: auto;
          //height: auto;
          width: 100%;
          height: 100%;
          border-radius: .32rem;
        }
        &:nth-child(3n+3) {
          margin-right: 0;
        }
      }
      .list-item2 {
        width: 100%;
        flex-shrink: 0;
        margin-bottom: .27rem;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/hall.vue